import React from 'react';
import { TrihowPadSlideGroup } from './variants/TrihowPad/TrihowPadSlideGroup';
import { GenericSlideGroup } from './variants/Generic/GenericSlideGroup';
import { useProductConfig } from '../../../_data/useProductConfig';
import { ProductType } from '../../../../../types/ProductType';
import { BaseSlideGroupProps } from '../../../../../types/SlideGroupProps';

export const SlideGroup = (props: BaseSlideGroupProps) => {
  const { unitId } = props;
  const { productType } = useProductConfig(unitId);

  switch (productType) {
    case ProductType.TrihowPad:
      return <TrihowPadSlideGroup {...props} />;
    case ProductType.Generic:
    default:
      return <GenericSlideGroup {...props} />;
  }
};
